<div *ngIf="habitosAlimentares" class="container-mensagem-alerta">
  <img alt="alerta" src="../../../../assets/images/icone-alerta-azul.svg">
  <p>
    O mapeamento de hábitos alimentares busca identificar o consumo real
    da pessoa para apoiar o acompanhamento nutricional. O formulário deve
    ser preenchido no aplicativo por pessoas vinculadas à linha de cuidado
    de sobrepeso e obesidade. Após o envio, ficará disponível abaixo para
    consulta pelo profissional de saúde. Se o formulário não estiver aqui,
    significa que o questionário ainda não foi respondido pela pessoa.
  </p>
</div>

<div *ngIf="habitosAlimentares" class="container-linhas">
  <div class="titulo-tabela">Mapeamento de refeições</div>

  <table>
    <tr *ngFor="let item of refeicoesArray">
      <td>
        <img [src]="item.icone" [alt]="item.nome">
        {{ item.nome }}
      </td>
      <td>{{ item.dados.horario || '-' }}</td>
      <td class="coluna-1">{{ item.dados.refeicao || '-' }}</td>
    </tr>
  </table>
</div>

<div *ngIf="habitosAlimentares" class="container-linhas">
  <div class="titulo-tabela">Sentimento em relação aos hábitos alimentares</div>
  <table>
    <tr>
      <td>{{habitosAlimentares.sentimentoHabitosAtuais}}</td>
    </tr>
  </table>
</div>

<p class="sem-registro" *ngIf="!habitosAlimentares">
  Hábitos alimentares ainda não foram registrados.
</p>
